
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexR7RxrPAx7iucW6o9d8WkCcGuy1rMypvycbZNO9zG9oAMeta } from "/home/rebrandfezzit/fezz.it/pages/index.vue?macro=true";
import { default as indexZuctqfOzGciQFqs9OU2lIzZR8SLLAn_UYJ9KRXiL2OAMeta } from "/home/rebrandfezzit/fezz.it/pages/blog/index.vue?macro=true";
import { default as _91slug_93yZmBV1FJZ3ttLx1jO5NYXBTavtWh_4buqPyYNxfRgnkMeta } from "/home/rebrandfezzit/fezz.it/pages/blog/[slug].vue?macro=true";
import { default as indexAhppAtVtyr9fUiXcKppWjMPk7qemrT26kLivrvgqZ1QMeta } from "/home/rebrandfezzit/fezz.it/pages/projects/index.vue?macro=true";
import { default as _91slug_93eJy4DRl54EeoKgrlKDx_45jGBRhKCSo6IO5fOTPH9URVoMeta } from "/home/rebrandfezzit/fezz.it/pages/projects/[slug].vue?macro=true";
import { default as component_45stubOEa550IyQASSxD1QaoX6AKaIlyc0LykBipxR4nTicc8Meta } from "/home/rebrandfezzit/fezz.it/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubOEa550IyQASSxD1QaoX6AKaIlyc0LykBipxR4nTicc8 } from "/home/rebrandfezzit/fezz.it/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/rebrandfezzit/fezz.it/pages/index.vue")
  },
  {
    name: "index___it",
    path: "/it",
    component: () => import("/home/rebrandfezzit/fezz.it/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/home/rebrandfezzit/fezz.it/pages/index.vue")
  },
  {
    name: "blog___it",
    path: "/it/blog",
    component: () => import("/home/rebrandfezzit/fezz.it/pages/blog/index.vue")
  },
  {
    name: "blog___en",
    path: "/en/blog",
    component: () => import("/home/rebrandfezzit/fezz.it/pages/blog/index.vue")
  },
  {
    name: "blog-slug___it",
    path: "/it/blog/:slug()",
    component: () => import("/home/rebrandfezzit/fezz.it/pages/blog/[slug].vue")
  },
  {
    name: "blog-slug___en",
    path: "/en/blog/:slug()",
    component: () => import("/home/rebrandfezzit/fezz.it/pages/blog/[slug].vue")
  },
  {
    name: "projects___it",
    path: "/it/progetti",
    component: () => import("/home/rebrandfezzit/fezz.it/pages/projects/index.vue")
  },
  {
    name: "projects___en",
    path: "/en/projects",
    component: () => import("/home/rebrandfezzit/fezz.it/pages/projects/index.vue")
  },
  {
    name: "projects-slug___it",
    path: "/it/progetti/:slug()",
    component: () => import("/home/rebrandfezzit/fezz.it/pages/projects/[slug].vue")
  },
  {
    name: "projects-slug___en",
    path: "/en/projects/:slug()",
    component: () => import("/home/rebrandfezzit/fezz.it/pages/projects/[slug].vue")
  },
  {
    name: component_45stubOEa550IyQASSxD1QaoX6AKaIlyc0LykBipxR4nTicc8Meta?.name,
    path: "/cloud",
    component: component_45stubOEa550IyQASSxD1QaoX6AKaIlyc0LykBipxR4nTicc8
  },
  {
    name: component_45stubOEa550IyQASSxD1QaoX6AKaIlyc0LykBipxR4nTicc8Meta?.name,
    path: "/hosting",
    component: component_45stubOEa550IyQASSxD1QaoX6AKaIlyc0LykBipxR4nTicc8
  },
  {
    name: component_45stubOEa550IyQASSxD1QaoX6AKaIlyc0LykBipxR4nTicc8Meta?.name,
    path: "/infomaniak",
    component: component_45stubOEa550IyQASSxD1QaoX6AKaIlyc0LykBipxR4nTicc8
  },
  {
    name: component_45stubOEa550IyQASSxD1QaoX6AKaIlyc0LykBipxR4nTicc8Meta?.name,
    path: "/vps",
    component: component_45stubOEa550IyQASSxD1QaoX6AKaIlyc0LykBipxR4nTicc8
  },
  {
    name: component_45stubOEa550IyQASSxD1QaoX6AKaIlyc0LykBipxR4nTicc8Meta?.name,
    path: "/sitemap.xml",
    component: component_45stubOEa550IyQASSxD1QaoX6AKaIlyc0LykBipxR4nTicc8
  }
]